import type { MessageInitShape, MessageShape } from '@bufbuild/protobuf'
import type { ConnectError } from '@connectrpc/connect'
import { useMutation } from '@connectrpc/connect-query'
import { checkDemandGroupCsv } from '@ebalance/proto/bffuser/v1/demand_group_service-DemandGroupService_connectquery'
import type {
  CheckDemandGroupCsvRequestSchema,
  CheckDemandGroupCsvResponseSchema,
} from '@ebalance/proto/bffuser/v1/demand_group_service_pb'
import type { UseMutationResult } from '@tanstack/react-query'

/**
 * 需要グループ CSV の Check mutation hook (demand-groups-upload-tracer
 * AC-01/02/06/07/09/10)。harmless (副作用なし): 件数サマリ + check_token を
 * 返すだけで demand_group テーブルへの書き込みは発生しない。
 */
export function useCheckDemandGroupCsv(): UseMutationResult<
  MessageShape<typeof CheckDemandGroupCsvResponseSchema>,
  ConnectError,
  MessageInitShape<typeof CheckDemandGroupCsvRequestSchema>
> {
  return useMutation(checkDemandGroupCsv)
}
